import apollo from '@/graphql'

import StoresQuery from '@/graphql/store/StoresQuery.gql'
import StoresWithRacksQuery from '@/graphql/store/StoresWithRacksQuery.gql'

// initial state
const state = {
  isStoresWithRacksLoading: false,
  searchTerm: '',
  stores: [],
  storesWithRacks: {},
  storeListLoading: false,
}

// getters
const getters = {
  isStoresWithRacksLoading: st => st.isStoresWithRacksLoading,
  stores: st => st.stores,
  storesWithRacks: st => st.storesWithRacks,
  storeListLoading: st => st.storeListLoading,
}

const mutations = {
  setStores(st, stores) {
    state.stores = stores
  },

  setStoresWithRacks(st, storesWithRacks) {
    state.storesWithRacks = storesWithRacks
  },

  setStoreListSearchTerm(state, term) {
    state.searchTerm = term
  },

  setStoreListLoading(state, loading) {
    state.storeListLoading = loading
  },
}

// actions
const actions = {
  async loadStores({ commit }, { isCampaignCreationFilter }) {
    commit('setStoreListLoading', true)
    const { data: { stores } } = await apollo.defaultClient
      .query({
        fetchPolicy: 'network-only',
        query: StoresQuery,
        variables: {
          companiesId:
            this.getters['Auth/user'].companiesId === 1
              ? null
              : this.getters['Auth/user'].companiesId,
          isCampaignCreationFilter: isCampaignCreationFilter || false,
        },
      })

    commit('setStores', stores)
    commit('setStoreListLoading', false)
  },

  async loadStoresWithRacks({ commit }, {
    id,
    isStockcheckEnabled,
    isUnmappedOnly,
    pagination,
    searchText,
  }) {
    state.isStoresWithRacksLoading = true

    const {
      data: {
        storesWithRacks,
      },
    } = await apollo.defaultClient.query({
      fetchPolicy: 'network-only',
      query: StoresWithRacksQuery,
      variables: Object.assign({
        id: +id, // convert to int
        isStockcheckEnabled,
        isUnmappedOnly,
        searchText,
      }, pagination),
    })

    state.isStoresWithRacksLoading = false

    commit('setStoresWithRacks', storesWithRacks)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/store/StoreList.js